import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import More from '../../../Components/Icons/More';
import axiosInstance from '../../../Services/axiosCommon';
import { Modal, notification } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { GetAccess } from '../../../Components/Utils/roles';
import ViewEmailSent from '../../Web/E-Mail/EmailSent/ViewEmailSent';


const ViewMore = ({ data, getData, id }) => {
  const { officeId } = useParams();
  const emailDelete = GetAccess("email_delete");
  const { confirm } = Modal;
  const [api, contextHolder] = notification.useNotification();

  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  const handleDelete = async (id, removevalue) => {
    confirm({
      title: `Do you Want to delete ${removevalue}?`,
      centered: true,
      icon: <ExclamationCircleFilled />,
      content: `The ${removevalue} will be removed from the List`,
      okText: "Yes",
      cancelText: "No",
      onOk() {
        axiosInstance
          .delete(`/PO/${id}`)
          .then((res) => {
            if (res.status === 200 || res.status === 201) {
              getData();
              api.success({
                message: `Deleted successfully`,
                description: res?.data?.msg || " ",
                placement: "bottomRight",
              });
            } else {
              api.error({
                message: `Delete failed`,
                description: res?.data?.msg || "Network error",
                placement: "bottomRight",
              });
            }
          })
          .catch((error) => {
            api.error({
              message: `Delete failed`,
              description: error?.response?.data?.msg || "Server error",
              placement: "bottomRight",
            });
          });
      },
    });
  };

  const showViewModal = () => {
    setIsViewModalOpen(true);
  };

  const handleCloseViewModal = () => {
    setIsViewModalOpen(false);
  };

  return (
    <>
      {contextHolder}
      <div className="text-[#344767] relative dropdown inline-block z-50">
        <div className="cursor-pointer text-xs mx-auto font-semibold flex items-center">
          <span
            className="w-7 h-7 bg-gray-50 flex flex-col items-center justify-center rounded-full"
            style={{ border: "1px solid #C0C0C0" }}
          >
            <More />
          </span>
        </div>

        <ul className="dropdown-menuOne text-[#344767] text-left rounded-lg absolute -left-[80px] -top-4 overflow-hidden hidden z-50 shadow-lg">
          <li className="w-[100px] bg-black block m-0">
            <span
              className="bg-white hover:bg-gray-100 py-2 px-2 block whitespace-no-wrap text-xs font-medium text-black cursor-pointer"
              onClick={showViewModal}
            >
              View
            </span>
          </li>

          {emailDelete && (
            <li className="">
              <a
                className="bg-white hover:bg-gray-100 text-black hover:text-black py-2 px-2 block whitespace-no-wrap text-xs font-medium"
                href="#"
                onClick={() => handleDelete(id, data?.client)}
              >
                Delete
              </a>
            </li>
          )}
        </ul>
      </div>

      {/* Popup Modal with styled content */}
      <Modal
        title="Email Details"
        open={isViewModalOpen}
        onCancel={handleCloseViewModal}
        footer={null}
        centered
        width={700}
        bodyStyle={{ paddingTop: 0 }}
      >
        <ViewEmailSent item={data} />
      </Modal>
    </>
  );
};

export default ViewMore;
